import { privateApi } from "../api/axios";
import { ISentence } from "../interfaces/ownerData";

export const getOwnerData = async () => {
    try {
        const response = await privateApi.get("api/ownerdatas/newscustomersentence");
        return response;
    } catch (error) {
        throw error;
    }
}

export const postOwnerData = async (data: ISentence) => {
    try {
        const response = await privateApi.post("api/ownerdatas/newscustomersentence", data);
        return response;
    } catch (error) {
        throw error;
    }
}